module.exports = __webpack_public_path__ + "img/057-burundi.073e30ba.svg";